import * as React from "react";
import { CommonHelper } from "../../../../../react-core/Helpers/CommonHelper";
import { SubAccountType } from "../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { ServiceProposition } from "../../../../../Wrap/Constants/Enums/ServiceProposition";
import { FundProductsQuery } from "../../../../../Wrap/Models/Domains/Investment/FundProductsQuery";
import { InvestmentSelectionAction } from "../../Action/InvestmentSelectionAction";
import { InvalideCodeWarning } from "./InvalideCodeWarning";
import { uniq } from "lodash";
import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { ResearchISTDispatcher } from "../../../../Dashboard/Components/ToolsAndLiterature/Store/Variable";

interface IFundCodesSearch {
    hiercharyId: string;
    type: SubAccountType;
    index: number;
    accountServiceProposition: ServiceProposition;
    canBeBought: boolean;
    canBeSold: boolean;
    CanBeTransferred?: boolean;
}

export const FundCodesSearch = (props: IFundCodesSearch) => {
    const [codes, setCodes] = React.useState([]);
    const [value, setValue] = React.useState(null);
    const [invalidCodes, setinvalidCodes] = React.useState([]);
    const [isSearching, setIsSearching] = React.useState(false);
    const onChangeCode = (value) => {
        const _codes = value
            .split(",")
            .filter((ele) => !CommonHelper.isNullOrEmpty(ele))
            .map((ele) => ele.toString().trim());
        if (_codes.length > 50) {return;}
        setValue(value);
        setCodes(_codes);
    };
    const searchCode = (e) => {
        e.preventDefault();
        if (codes.length == 0) {return;}
        setIsSearching(true);
        setinvalidCodes([]);
        const query: FundProductsQuery = {};
        if (props.canBeBought) {
            query["CanBeBought"] = true;
        }
        if (props.canBeSold) {
            query["CanBeSold"] = true;
        }
        if (props.CanBeTransferred) {
            query["IncludeInsuredFund"] = false;
	    query["CanBeTransferred"] = true;
        }

        query["ProductWrapperTypes"] = [props.type];
        query["FundCodes"] = codes;
        query["ServiceProposition"] = props.accountServiceProposition;

        setIsSearching(true);
        if (props.index) {InvestmentSelectionAction.setEditingTransferNumber(props.index);}
        InvestmentSelectionAction.searchFundProducts(
            query,
            props.hiercharyId,
            (data) => {
                const canAdd = [];
                const invalidCode = [];
                codes.forEach((ele) => {
                    const findObj = data.Results.find(
                        (item) =>
                            item.ProductCode.toLowerCase() == ele.toLowerCase() ||
                            item.ProductCode.toLowerCase() == (ele + ".LN").toLowerCase()
                    );
                    if (findObj) {
                        canAdd.push(findObj);
                    } else {
                        invalidCode.push(ele);
                    }
                });
                ResearchISTDispatcher.dispatch({ actionType: ActionType.Success, payload: canAdd });
                setinvalidCodes(invalidCode);
                InvestmentSelectionAction.addInvestments(uniq(canAdd));
                setIsSearching(false);
            },
            50
        );
    };
    return (
        <div className="mb-35">
            <h3>Search by fund code</h3>
            <div className="controls-textarea">
                <label className="text-size-14">
                    Fund code search (Multiple fund codes can be added at the same time separated by a comma, e.g. Code
                    1, Code 2, Code 3)
                </label>
                <textarea rows={5} onChange={(e) => onChangeCode(e.target.value)} value={value}></textarea>
                <p className="mt-10 mb-0">Codes Left: {50 - codes.length}</p>
                {invalidCodes.length > 0 && <InvalideCodeWarning codes={invalidCodes} />}
            </div>
            <div className="text-right">
                <button className={`btn secondary ${isSearching ? "is-busy" : ""}`} onClick={(e) => searchCode(e)}>
                    Add codes
                </button>
            </div>
        </div>
    );
};
